let GetFromCloud = {}

GetFromCloud.getAmountRaisedFromGoogleSheets = async function getAmountRaisedFromGoogleSheets() {
    var requestOptions = {
  method: 'GET',
  redirect: 'follow'
};

return fetch("https://script.google.com/macros/s/AKfycbyBm69AMEO8zQtUpwjysa1ynWv5pYPnKqFOZMYRrWTn-K3s8SX1ZnAWcQqfy3C3e84/exec", requestOptions)
  .then(response => response.json())
  .then(result => {return result})
  .catch(error => {return error});
}

export default GetFromCloud